import { Button, Heading, Markdown } from '@altify/components';
import { View } from 'react-native';
import { useContent } from '@altify/utils';
import { content } from './ActionNotAllowedModal.content';
import { DialogOrBottomSheet } from 'components/DialogOrBottomSheet/DialogOrBottomSheet';
import { openZendesk } from 'utils/zendesk';
import ExclamationIcon from 'assets/icons/exclamation_outline_white.svg';

const ActionNotAllowedModal = ({
  title,
  description,
  onClose,
  isAuthenticated,
  showFooter = false
}: {
  title: string;
  description?: string;
  onClose: () => void;
  isAuthenticated: boolean;
  showFooter?: boolean;
}) => {
  const localizedContent = useContent(content);
  const errorImg = ExclamationIcon;
  
  return (
    <DialogOrBottomSheet
      isOpen={true}
      dismissable={true}
      onClose={onClose}
      blurEnabled={true}
      isAuthenticated={isAuthenticated}
      footerContent={
        showFooter ?
          <View className="flex w-full items-center mt-6 gap-2">
            <Button
              size="large"
              onPress={onClose}
              text={localizedContent.understand}
            />
            <Button
              color="transparent"
              size="large"
              onPress={() => {
                onClose();
                openZendesk();
              }}
              text={localizedContent.contactSupport}
            />
          </View>
        : 
        null
      }>
      <View className="w-full flex flex-col items-center px-8 py-4">
        <View className="w-full items-center justify-center">
          <View className="mb-4 mt-6 items-center">
            <img src={errorImg} alt="error-exclamation" className="mx-auto w-24" />
            <Heading level={4} className="my-4 text-center font-normal">
              {title}
            </Heading>
            
            {description && (
              <View className="flex justify-center items-center text-center">
                <Markdown
                  styles={{
                    link: {
                      color: '#ffffff',
                      fontWeight: 300,
                      textDecorationLine: 'underline',
                      fontFamily: 'bozon',
                    },
                    text: {
                      color: '#ffffff',
                      fontFamily: 'Bozon',
                      lineHeight: 25,
                      fontWeight: 300,
                      width: 'auto',
                      textAlign: 'center',
                    },
                    paragraph: {
                      color: '#ffffff',
                      justifyContent: 'center',
                      // @ts-ignore
                      display: 'block',
                      fontFamily: 'Bozon',
                      lineHeight: 25,
                      fontWeight: 300,
                    }
                  }}>
                  {description}
                </Markdown>
              </View>
            )}
          </View>
        </View>
      </View>
    </DialogOrBottomSheet>
  );
};

export default ActionNotAllowedModal;
